export default class Btn{
    constructor(kv){

        this.kv = kv;

    }

    /* ---------------------------------------------------

　　　-- prev next のボタンの表示

    --------------------------------------------------- */


    show(){

        //if(this.kv.status.index > 0){
            TweenMax.set(this.kv.detailPrevBtn, {
                display: 'none',
                opacity: 0,
                scale : 0,
                y:30,
                transformOrigin: "50% 50%",
            });
            TweenMax.to(this.kv.detailPrevBtn, 0.2 ,{
                display:'block',
                opacity:1,
                ease: this.kv.easeBack
            });
            TweenMax.to(this.kv.detailPrevBtn, 0.6 ,{
                scale : 1,
                y:0,
                transformOrigin: "50% 50%",
                ease: this.kv.easeBack
            });
        //}
        //if(this.kv.status.index < this.kv.max){
            TweenMax.set(this.kv.detailNextBtn, {
                display: 'none',
                opacity: 0,
                scale : 0,
                y:30,
                transformOrigin: "50% 50%",
            });
            TweenMax.to(this.kv.detailNextBtn, 0.2 ,{
                display:'block',
                opacity:1,
                ease: this.kv.easeBack
            });
            TweenMax.to(this.kv.detailNextBtn, 0.6 ,{
                scale : 1,
                y:0,
                transformOrigin: "50% 50%",
                ease: this.kv.easeBack
            });
        //}

    }

    hide(){

        TweenMax.to([this.kv.detailPrevBtn,this.kv.detailNextBtn], 0.1 ,{
            y: 5,
            ease: this.kv.easeBack,
            onComplete:() => {
                TweenMax.to([this.kv.detailPrevBtn,this.kv.detailNextBtn], 0.2 , {
                    display: 'none',
                    opacity: 0,
                    y: -30,
                    ease: this.kv.easeBack,
                });
            }
        });

    }

    backBtn(type){

        switch(type) {
            case 'hide':
                TweenMax.to(this.kv.back, 0.6, {
                    opacity: 0,
                    display: 'none',
                    scale: 0.8,
                    ease: Sine.easeOut,
                });
                break;
            case 'show':
                // 処理を書く
                break;
        }

    }


}